<template>
  <div>
    <v-row class="pa-4">
      <v-text-field :label="$t('settings.tripPolicy.title')" v-model="title" class="pr-2" />
      <v-text-field :label="$t('settings.customWebpage.headers.alias')" v-model="alias" class="px-2" />
      <v-text-field :label="$t('settings.customWebpage.icon')" v-model="icon" class="px-2" :append-outer-icon="icon" />
      <v-spacer></v-spacer>
      <v-btn @click="save" class="accent"
        >{{ $t("global.save") }}
        <v-icon>border_color</v-icon>
      </v-btn>
    </v-row>

    <quill-editor v-model="html" :options="quillOptions" ref="myQuillEditor"> </quill-editor>

    <ajax-file :items="files" assignment="custom_webpage" />

    <h2 style="margin-top: 35px;">{{ $t("settings.tripPolicy.preview") }}:</h2>

    <h1>{{ title }}</h1>
    <div class="ql-container ql-snow" style="border: none">
      <div v-html="html" class="ql-editor"></div>
    </div>

    <multiple-file-download :files="files" @download="fileId => download(fileId)" />
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import AjaxFile from "../../components/CustomInputComponents/AjaxFile";
import MultipleFileDownload from "../../components/MultipleFileDownload";
import downloadFile from "../../repository/downloadFile";

export default {
  name: "SettingsCustomWebpageEditView",
  components: { MultipleFileDownload, AjaxFile, quillEditor },
  data: () => ({
    html: "",
    title: "",
    alias: "",
    files: [],
    icon: "info",
    quillOptions: {
      readOnly: "true",
      bounds: "div",
      //formats: ['color'],
      modules: {
        toolbar: [
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["blockquote", "code-block"],

          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }], // superscript/subscript
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction

          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],

          ["clean"], // remove formatting button

          ["link", "image", "video"] // link and image, video
        ]
      }
    }
  }),
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  methods: {
    download(fileId) {
      downloadFile("custom-webpage/get-file?fileId=" + fileId);
    },
    save() {
      this.axios
        .post("settings/custom-webpage/save", {
          id: this.$route.params.id === "new" ? null : this.$route.params.id,
          alias: this.alias,
          title: this.title,
          content: this.html,
          icon: this.icon,
          files: this.files
        })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            this.$router.push("/settings/custom-webpage");
          }
        })
        .catch(() => {
          this.$store.dispatch("alertDialog", {
            content: this.$t("global.error.generalError.content"),
            title: this.$t("global.error.generalError.title")
          });
        });
    }
  },
  created() {
    if (this.$route.params.id !== "new") {
      this.axios.get("settings/custom-webpage/get", { params: { id: this.$route.params.id } }).then(response => {
        this.title = response.data.title;
        this.html = response.data.content;
        this.alias = response.data.alias;
        this.icon = response.data.icon;
        this.files = response.data.files;
      });
    }
  }
};
</script>

<style scoped></style>
